import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable()
export class ImageToPdfService {

  constructor(
      private http: HttpClient,
  ) { }


  convertImageToPdf$(remoteFileId: string): Observable<Blob> {
  const url = `${environment.apiURL}/tools/pdf/convert-image`;
  return this.http.post(url, { remoteFileId }, { responseType: 'blob' });
  }
}

